/*
Incase the token expires or there is problem fetching data from server
FakeApiEnabled = true
*/
const FakeApiEnabled = true;

export const FakeArtwork =
  "https://www.fonepay.com/uploads/images/GOldstar-web.jpg";

// https://dev-api-offer-backend.fonepay.com/api/app/v1
// /offer/search?size=5&latitude=27.7032021&longitude=85.3204706&next=0&opennow=1

// For categories offer - size=6&categories=112bcad2-8b41-4b6a-ae1c-71a697fef15f
// id from SubMerchantCategorySearch
export const OfferSearch = {
  code: 200,
  message: "success",
  data: {
    pagination: { previous: 0, next: 5, size: 5 },
    offers: [
      {
        id: "b45335c3-256f-4371-96e4-5c08cc587db3",
        title: "(20%) Bota momo for putalisadak",
        description: "20% Bota momo for pulatisadak",
        artwork:
          "https://dev-cdn-offer.fonepay.com/offercontent/offer/0963200b42d74819a1ab6e82d179e4ff",
        dealType: 1,
        dealDiscount: 20.0,
        offerStatus: 1,
        validFrom: 1578334500000,
        validTo: 1599243300000,
        subMerchants: [
          {
            id: "de4916bf-611a-4433-9f0b-e3c34804c120",
            categoryId: "ed5bd35f-b9a3-45e6-b470-41e0399829d7",
            name: "Bota Simply Momo (near fawesomeapps)1",
            longitude: 85.32210916560666,
            latitude: 27.70173062091959,
            distance: 0.2297704,
            openNow: 1,
            cover:
              "https://dev-cdn-offer.fonepay.com/offercontent/d1977fee2beb4566ae770e0a3c9a0698"
          },
          {
            id: "f7681568-728b-49e9-b4da-301939cb03c0",
            categoryId: "fe478c67-0489-11ea-96f5-04015db0f001",
            name: "Bota Simply Momo",
            longitude: 85.32593697567131,
            latitude: 27.715642176273082,
            distance: 1.4842588,
            openNow: 1,
            cover:
              "https://dev-cdn-offer.fonepay.com/offercontent/merchant/fb496acd87c4498fab93b50f354311c6"
          },
          {
            id: "96b38e94-4dfa-479c-90c3-183a8b2852ee",
            categoryId: "ed5bd35f-b9a3-45e6-b470-41e0399829d7",
            name: "Bota Simply Momo (baneshwor)",
            longitude: 85.33695776728973,
            latitude: 27.692830589522426,
            distance: 1.9911869,
            openNow: 1,
            cover:
              "https://dev-cdn-offer.fonepay.com/offercontent/d1977fee2beb4566ae770e0a3c9a0698"
          }
        ]
      },
      {
        id: "8fb86549-4ce5-4c58-8ec0-85c1ecce1926",
        title: "package in bali",
        description: "package in bali",
        artwork:
          "https://dev-cdn-offer.fonepay.com/offercontent/offer/47fb02f50adc454a8b04ed2e08ad1ec6",
        dealType: 1,
        dealDiscount: 10.0,
        offerStatus: 1,
        validFrom: 1569953700000,
        validTo: 1582273800000,
        subMerchants: [
          {
            id: "55812b8f-0c59-46c3-af73-380ffc078284",
            categoryId: "112bcad2-8b41-4b6a-ae1c-71a697fef15f",
            name: "Buddha Air",
            longitude: 85.31723860419925,
            latitude: 27.70744430532618,
            distance: 0.56898993,
            openNow: 1,
            cover:
              "https://dev-cdn-offer.fonepay.com/offercontent/merchant/7f97a91eff0d43f786c62b1ed6f1069d"
          }
        ]
      },
      {
        id: "94566e12-dfde-49b4-8191-5da57111c7ee",
        title: "Fly to AMERICA!!! on 100% off",
        description: "Fly to AMERICA!!!",
        artwork:
          "https://dev-cdn-offer.fonepay.com/offercontent/offer/c561e6f35a0a4562843def564bf68428",
        dealType: 1,
        dealDiscount: 100.0,
        offerStatus: 1,
        validFrom: 1568398500000,
        validTo: 1587583800000,
        subMerchants: [
          {
            id: "55812b8f-0c59-46c3-af73-380ffc078284",
            categoryId: "112bcad2-8b41-4b6a-ae1c-71a697fef15f",
            name: "Buddha Air",
            longitude: 85.31723860419925,
            latitude: 27.70744430532618,
            distance: 0.56898993,
            openNow: 1,
            cover:
              "https://dev-cdn-offer.fonepay.com/offercontent/merchant/7f97a91eff0d43f786c62b1ed6f1069d"
          }
        ]
      },
      {
        id: "97a3050d-85a1-49d1-bed5-41ee0f83a50f",
        title: "Offer2",
        description: "Offer",
        artwork:
          "https://dev-cdn-offer.fonepay.com/offercontent/offer/e1f021fc76a84924bae77f6cac69ca80",
        dealType: 1,
        dealDiscount: 5.0,
        offerStatus: 1,
        validFrom: 1569912300000,
        validTo: 1593862200000,
        subMerchants: [
          {
            id: "55812b8f-0c59-46c3-af73-380ffc078284",
            categoryId: "112bcad2-8b41-4b6a-ae1c-71a697fef15f",
            name: "Buddha Air",
            longitude: 85.31723860419925,
            latitude: 27.70744430532618,
            distance: 0.56898993,
            openNow: 1,
            cover:
              "https://dev-cdn-offer.fonepay.com/offercontent/merchant/7f97a91eff0d43f786c62b1ed6f1069d"
          }
        ]
      },
      {
        id: "b28cce35-99c4-4533-94a5-4960b43fa90a",
        title: "Fly to Africa for 30% off",
        description: "asda",
        artwork:
          "https://dev-cdn-offer.fonepay.com/offercontent/offer/35712f44399748c5ab9f36bd4a7639d7",
        dealType: 1,
        dealDiscount: 100.0,
        offerStatus: 1,
        validFrom: 1568312100000,
        validTo: 1590694200000,
        subMerchants: [
          {
            id: "55812b8f-0c59-46c3-af73-380ffc078284",
            categoryId: "112bcad2-8b41-4b6a-ae1c-71a697fef15f",
            name: "Buddha Air",
            longitude: 85.31723860419925,
            latitude: 27.70744430532618,
            distance: 0.56898993,
            openNow: 1,
            cover:
              "https://dev-cdn-offer.fonepay.com/offercontent/merchant/7f97a91eff0d43f786c62b1ed6f1069d"
          }
        ]
      }
    ]
  }
};

// TODO: need category: {id, name} also
export const OfferSearchCategories = {
  code: 200,
  message: "success",
  data: {
    pagination: { previous: null, next: 6, size: 6 },
    offers: [
      {
        id: "8fb86549-4ce5-4c58-8ec0-85c1ecce1926",
        title: "package in bali",
        description: "package in bali",
        artwork:
          "https://dev-cdn-offer.fonepay.com/offercontent/offer/47fb02f50adc454a8b04ed2e08ad1ec6",
        dealType: 1,
        dealDiscount: 10.0,
        offerStatus: 1,
        validFrom: 1569953700000,
        validTo: 1582273800000,
        subMerchants: [
          {
            id: "55812b8f-0c59-46c3-af73-380ffc078284",
            categoryId: "112bcad2-8b41-4b6a-ae1c-71a697fef15f",
            name: "Buddha Air",
            longitude: 85.31723860419925,
            latitude: 27.70744430532618,
            distance: null,
            openNow: null,
            cover:
              "https://dev-cdn-offer.fonepay.com/offercontent/merchant/7f97a91eff0d43f786c62b1ed6f1069d"
          }
        ]
      },
      {
        id: "94566e12-dfde-49b4-8191-5da57111c7ee",
        title: "Fly to AMERICA!!! on 100% off",
        description: "Fly to AMERICA!!!",
        artwork:
          "https://dev-cdn-offer.fonepay.com/offercontent/offer/c561e6f35a0a4562843def564bf68428",
        dealType: 1,
        dealDiscount: 100.0,
        offerStatus: 1,
        validFrom: 1568398500000,
        validTo: 1587583800000,
        subMerchants: [
          {
            id: "55812b8f-0c59-46c3-af73-380ffc078284",
            categoryId: "112bcad2-8b41-4b6a-ae1c-71a697fef15f",
            name: "Buddha Air",
            longitude: 85.31723860419925,
            latitude: 27.70744430532618,
            distance: null,
            openNow: null,
            cover:
              "https://dev-cdn-offer.fonepay.com/offercontent/merchant/7f97a91eff0d43f786c62b1ed6f1069d"
          }
        ]
      },
      {
        id: "97a3050d-85a1-49d1-bed5-41ee0f83a50f",
        title: "Offer2",
        description: "Offer",
        artwork:
          "https://dev-cdn-offer.fonepay.com/offercontent/offer/e1f021fc76a84924bae77f6cac69ca80",
        dealType: 1,
        dealDiscount: 5.0,
        offerStatus: 1,
        validFrom: 1569912300000,
        validTo: 1593862200000,
        subMerchants: [
          {
            id: "55812b8f-0c59-46c3-af73-380ffc078284",
            categoryId: "112bcad2-8b41-4b6a-ae1c-71a697fef15f",
            name: "Buddha Air",
            longitude: 85.31723860419925,
            latitude: 27.70744430532618,
            distance: null,
            openNow: null,
            cover:
              "https://dev-cdn-offer.fonepay.com/offercontent/merchant/7f97a91eff0d43f786c62b1ed6f1069d"
          }
        ]
      },
      {
        id: "b28cce35-99c4-4533-94a5-4960b43fa90a",
        title: "Fly to Africa for 30% off",
        description: "asda",
        artwork:
          "https://dev-cdn-offer.fonepay.com/offercontent/offer/35712f44399748c5ab9f36bd4a7639d7",
        dealType: 1,
        dealDiscount: 100.0,
        offerStatus: 1,
        validFrom: 1568312100000,
        validTo: 1590694200000,
        subMerchants: [
          {
            id: "55812b8f-0c59-46c3-af73-380ffc078284",
            categoryId: "112bcad2-8b41-4b6a-ae1c-71a697fef15f",
            name: "Buddha Air",
            longitude: 85.31723860419925,
            latitude: 27.70744430532618,
            distance: null,
            openNow: null,
            cover:
              "https://dev-cdn-offer.fonepay.com/offercontent/merchant/7f97a91eff0d43f786c62b1ed6f1069d"
          }
        ]
      },
      {
        id: "d8c36e47-7753-4949-a814-a9e7a0789189",
        title: "UIT ASlkdjaklsdj",
        description: "jaskldjalksdj",
        artwork:
          "https://dev-cdn-offer.fonepay.com/offercontent/offer/9432e83821f44e09acef1cd86bf81297",
        dealType: 1,
        dealDiscount: 100.0,
        offerStatus: 1,
        validFrom: 1568225700000,
        validTo: 1581704100000,
        subMerchants: [
          {
            id: "55812b8f-0c59-46c3-af73-380ffc078284",
            categoryId: "112bcad2-8b41-4b6a-ae1c-71a697fef15f",
            name: "Buddha Air",
            longitude: 85.31723860419925,
            latitude: 27.70744430532618,
            distance: null,
            openNow: null,
            cover:
              "https://dev-cdn-offer.fonepay.com/offercontent/merchant/7f97a91eff0d43f786c62b1ed6f1069d"
          }
        ]
      },
      {
        id: "df7a731d-4d5b-400d-bdfb-2daf742e7bf8",
        title: "package in Germany",
        description: "package in Germany",
        artwork:
          "https://dev-cdn-offer.fonepay.com/offercontent/offer/8b84acf4dfad48728f11dfd4463685d4",
        dealType: 1,
        dealDiscount: 10.0,
        offerStatus: 1,
        validFrom: 1575435600000,
        validTo: 1581102000000,
        subMerchants: [
          {
            id: "55812b8f-0c59-46c3-af73-380ffc078284",
            categoryId: "112bcad2-8b41-4b6a-ae1c-71a697fef15f",
            name: "Buddha Air",
            longitude: 85.31723860419925,
            latitude: 27.70744430532618,
            distance: null,
            openNow: null,
            cover:
              "https://dev-cdn-offer.fonepay.com/offercontent/merchant/7f97a91eff0d43f786c62b1ed6f1069d"
          }
        ]
      }
    ]
  }
};

// /api/app/v1/offer/0df49df8-a202-4114-8d45-6a59dcac4851
export const OfferById = {
  code: 200,
  message: "success",
  data: {
    offer: {
      id: "0df49df8-a202-4114-8d45-6a59dcac4851",
      title: "Free Bota Momo",
      description: "Free momo",
      subMerchants: [
        {
          id: "f7681568-728b-49e9-b4da-301939cb03c0",
          name: "Bota Simply Momo",
          email: "md.shiddiki@dil-rjcorp.com",
          description:
            "Bota was established on May 21st, 2015 by a foreign concept to serve and bring the best quality food and restaurant chain to cater the Nepalese market. Bota is Nepal’s one of the most emerging food \nconglomerate. \n\nBota Food And Restaurant specializes in production sector, service, food and restaurant chain and more.\n\nThe company is set to open multiple outlets all over the country. Bota, being already in operation in various locations has received many accolades in such a short period of time. \n\nYour friendly neighborhood Bota Food and Restaurant promises to deliver wide range of yummylicious food that will keep you drooling for more.\nThe core objective of the company is to deliver “the best service”, “the best quality”, “the best food”, “and “the utmost hygiene” at “ the best price”.\n",
          category: {
            id: "fe478c67-0489-11ea-96f5-04015db0f001",
            name: "None",
            description: "None",
            image:
              "https://dev-cdn-offer.fonepay.com/offercontent/d1977fee2beb4566ae770e0a3c9a0698"
          },
          cover:
            "https://dev-cdn-offer.fonepay.com/offercontent/merchant/fb496acd87c4498fab93b50f354311c6",
          logo:
            "https://dev-cdn-offer.fonepay.com/offercontent/merchant/c229cffadc6943d3834a6bde495092f1",
          city: "Kathmandu",
          tole: "Tole",
          province: {
            id: "728a8cb6-19df-4d26-bb7a-9700d5880bab",
            name: "State-3"
          },
          district: {
            id: "202d67ed-29f0-4869-b642-4f93e7c8d613",
            province: "728a8cb6-19df-4d26-bb7a-9700d5880bab",
            name: "Kathmandu"
          },
          municipality: "Kathmandu",
          latitude: 27.715642176273082,
          longitude: 85.32593697567131,
          contactNumber: "980107944",
          mobileNumber: "9801079445",
          ownersInformation: "Owners\u0027s information",
          website: "http://www.botamomo.com/",
          facebook: "https://www.facebook.com/botasimplymomo/",
          twitter: "https://www.twitter.com/botasimplymomo/",
          instagram: "https://www.instagram.com/botasimplymomo/",
          youtube: "https://www.youtube.com/botasimplymomo/",
          openingHours: [
            {
              id: "2ab8715f-b0df-41fe-9d49-a0f6ec7251dc",
              openingDay: 1,
              openingTime: 540,
              closingTime: 1260
            },
            {
              id: "ab0e8a12-5498-4f5d-9d31-dcdafdcceb29",
              openingDay: 2,
              openingTime: 540,
              closingTime: 1260
            },
            {
              id: "b0cf2be3-7ce3-462a-82fe-e159eb85a289",
              openingDay: 6,
              openingTime: 575,
              closingTime: 1090
            },
            {
              id: "d35b3393-0ae3-494c-91a8-3fbdb2dcc76a",
              openingDay: 0,
              openingTime: 540,
              closingTime: 1260
            },
            {
              id: "d6ff51e4-c9d2-4fd4-97b8-c89afe1e4cb5",
              openingDay: 5,
              openingTime: 540,
              closingTime: 1260
            },
            {
              id: "e4faf36c-85e2-48b8-8e32-e02beb918337",
              openingDay: 3,
              openingTime: 540,
              closingTime: 1260
            },
            {
              id: "fbd75889-d2f0-478d-9216-d374d9674356",
              openingDay: 4,
              openingTime: 540,
              closingTime: 1260
            }
          ]
        }
      ],
      artwork:
        "https://dev-cdn-offer.fonepay.com/offercontent/offer/a9c5b1b8db3940d49f7aa2f991687bcb",
      dealType: 2,
      dealDiscount: 82.0,
      offerStatus: 1,
      validFrom: 1568744100000,
      validTo: 1601748900000
    }
  }
};

// /api/app/v1/submerchant/f7681568-728b-49e9-b4da-301939cb03c0
export const SubMerchantById = {
  code: 200,
  message: "success",
  data: {
    subMerchant: {
      id: "f7681568-728b-49e9-b4da-301939cb03c0",
      name: "Bota Simply Momo",
      email: "md.shiddiki@dil-rjcorp.com",
      description:
        "Bota was established on May 21st, 2015 by a foreign concept to serve and bring the best quality food and restaurant chain to cater the Nepalese market. Bota is Nepal’s one of the most emerging food \nconglomerate. \n\nBota Food And Restaurant specializes in production sector, service, food and restaurant chain and more.\n\nThe company is set to open multiple outlets all over the country. Bota, being already in operation in various locations has received many accolades in such a short period of time. \n\nYour friendly neighborhood Bota Food and Restaurant promises to deliver wide range of yummylicious food that will keep you drooling for more.\nThe core objective of the company is to deliver “the best service”, “the best quality”, “the best food”, “and “the utmost hygiene” at “ the best price”.\n",
      category: {
        id: "fe478c67-0489-11ea-96f5-04015db0f001",
        name: "None",
        description: "None",
        image:
          "https://dev-cdn-offer.fonepay.com/offercontent/d1977fee2beb4566ae770e0a3c9a0698"
      },
      cover:
        "https://dev-cdn-offer.fonepay.com/offercontent/merchant/fb496acd87c4498fab93b50f354311c6",
      logo:
        "https://dev-cdn-offer.fonepay.com/offercontent/merchant/c229cffadc6943d3834a6bde495092f1",
      city: "Kathmandu",
      tole: "Tole",
      province: { id: "728a8cb6-19df-4d26-bb7a-9700d5880bab", name: "State-3" },
      district: {
        id: "202d67ed-29f0-4869-b642-4f93e7c8d613",
        province: "728a8cb6-19df-4d26-bb7a-9700d5880bab",
        name: "Kathmandu"
      },
      municipality: "Kathmandu",
      latitude: 27.715642176273082,
      longitude: 85.32593697567131,
      contactNumber: "980107944",
      mobileNumber: "9801079445",
      ownersInformation: "Owners\u0027s information",
      website: "http://www.botamomo.com/",
      facebook: "https://www.facebook.com/botasimplymomo/",
      twitter: "https://www.twitter.com/botasimplymomo/",
      instagram: "https://www.instagram.com/botasimplymomo/",
      youtube: "https://www.youtube.com/botasimplymomo/",
      openingHours: [
        {
          id: "2ab8715f-b0df-41fe-9d49-a0f6ec7251dc",
          openingDay: 1,
          openingTime: 540,
          closingTime: 1260
        },
        {
          id: "ab0e8a12-5498-4f5d-9d31-dcdafdcceb29",
          openingDay: 2,
          openingTime: 540,
          closingTime: 1260
        },
        {
          id: "b0cf2be3-7ce3-462a-82fe-e159eb85a289",
          openingDay: 6,
          openingTime: 575,
          closingTime: 1090
        },
        {
          id: "d35b3393-0ae3-494c-91a8-3fbdb2dcc76a",
          openingDay: 0,
          openingTime: 540,
          closingTime: 1260
        },
        {
          id: "d6ff51e4-c9d2-4fd4-97b8-c89afe1e4cb5",
          openingDay: 5,
          openingTime: 540,
          closingTime: 1260
        },
        {
          id: "e4faf36c-85e2-48b8-8e32-e02beb918337",
          openingDay: 3,
          openingTime: 540,
          closingTime: 1260
        },
        {
          id: "fbd75889-d2f0-478d-9216-d374d9674356",
          openingDay: 4,
          openingTime: 540,
          closingTime: 1260
        }
      ]
    }
  }
};

// TODO: need collection: {id, name} also
// For Offer List page - get id from CollectionList.js
// /api/app/v1/collection/search?next=0&size=2&id=f3097a0f-3bb1-4d8c-9218-a948ec52b43b
export const CollectionOfferSearch = {
  code: 200,
  message: "success",
  data: {
    pagination: { previous: 0, next: 2, size: 2 },
    offers: [
      {
        id: "d8c36e47-7753-4949-a814-a9e7a0789189",
        title: "UIT ASlkdjaklsdj",
        artwork:
          "https://dev-cdn-offer.fonepay.com/offercontent/offer/9432e83821f44e09acef1cd86bf81297",
        dealType: 1,
        dealDiscount: 100.0,
        subMerchants: [
          {
            id: "55812b8f-0c59-46c3-af73-380ffc078284",
            categoryId: "112bcad2-8b41-4b6a-ae1c-71a697fef15f",
            name: "Buddha Air",
            longitude: 85.31723860419925,
            latitude: 27.70744430532618,
            distance: null,
            openNow: null,
            cover:
              "https://dev-cdn-offer.fonepay.com/offercontent/merchant/7f97a91eff0d43f786c62b1ed6f1069d"
          }
        ],
        weight: 1.0
      },
      {
        id: "df7a731d-4d5b-400d-bdfb-2daf742e7bf8",
        title: "package in Germany",
        artwork:
          "https://dev-cdn-offer.fonepay.com/offercontent/offer/8b84acf4dfad48728f11dfd4463685d4",
        dealType: 1,
        dealDiscount: 10.0,
        subMerchants: [
          {
            id: "55812b8f-0c59-46c3-af73-380ffc078284",
            categoryId: "112bcad2-8b41-4b6a-ae1c-71a697fef15f",
            name: "Buddha Air",
            longitude: 85.31723860419925,
            latitude: 27.70744430532618,
            distance: null,
            openNow: null,
            cover:
              "https://dev-cdn-offer.fonepay.com/offercontent/merchant/7f97a91eff0d43f786c62b1ed6f1069d"
          }
        ],
        weight: 1.0
      }
    ]
  }
};

// https://dev-api-offer-backend.fonepay.com/api/app/v1/collection/featured?size=5
export const FeaturedOffer = {
  code: 200,
  message: "success",
  data: {
    collections: [
      {
        collection: {
          id: "f7b56f26-d832-42f9-9d41-be8fbbb75033",
          title: "Featured",
          description: "This is featured",
          type: 1,
          weight: 100.0,
          artwork:
            "https://dev-cdn-offer.fonepay.com/offercontent/offer_collection/babc308ec8244ea5bb8f726ec9bc78d0"
        },
        offers: [
          {
            id: "0df49df8-a202-4114-8d45-6a59dcac4851",
            title: "Free Bota Momo",
            artwork:
              "https://dev-cdn-offer.fonepay.com/offercontent/offer/a9c5b1b8db3940d49f7aa2f991687bcb",
            dealType: 2,
            dealDiscount: 82.0,
            subMerchants: [
              {
                id: "f7681568-728b-49e9-b4da-301939cb03c0",
                categoryId: "fe478c67-0489-11ea-96f5-04015db0f001",
                name: "Bota Simply Momo",
                longitude: 85.32593697567131,
                latitude: 27.715642176273082,
                distance: null,
                openNow: null,
                cover:
                  "https://dev-cdn-offer.fonepay.com/offercontent/merchant/fb496acd87c4498fab93b50f354311c6"
              }
            ],
            weight: 0.0
          },
          {
            id: "348b9be9-4f43-46e6-bc6b-f86d494f7725",
            title: "asdsssadasda",
            artwork:
              "https://dev-cdn-offer.fonepay.com/offercontent/offer/209c3ec8471f4162af265f89f878f032",
            dealType: 1,
            dealDiscount: 100.0,
            subMerchants: [
              {
                id: "81bd2c34-accd-41ae-b602-afb848054a65",
                categoryId: "354eec1e-b4b7-431b-a2e9-15fe027bbe56",
                name: "Ratna Jwelery",
                longitude: 85.32460659999992,
                latitude: 27.7121469,
                distance: null,
                openNow: null,
                cover:
                  "https://dev-cdn-offer.fonepay.com/offercontent/d1977fee2beb4566ae770e0a3c9a0698"
              },
              {
                id: "c9322194-3e22-4801-a99b-42cbdd2d0e60",
                categoryId: "25137336-cc9d-4d40-a196-2cdbb4f302ac",
                name: "Cartier Jwelery",
                longitude: 85.32460659999992,
                latitude: 27.7121469,
                distance: null,
                openNow: null,
                cover:
                  "https://dev-cdn-offer.fonepay.com/offercontent/d1977fee2beb4566ae770e0a3c9a0698"
              },
              {
                id: "f925f68d-bbc1-44b5-b151-7986ffef7e4c",
                categoryId: "25137336-cc9d-4d40-a196-2cdbb4f302ac",
                name: "Harry Winston Jwelery",
                longitude: 85.32460659999992,
                latitude: 27.7121469,
                distance: null,
                openNow: null,
                cover:
                  "https://dev-cdn-offer.fonepay.com/offercontent/d1977fee2beb4566ae770e0a3c9a0698"
              }
            ],
            weight: 0.0
          },
          {
            id: "b45335c3-256f-4371-96e4-5c08cc587db3",
            title: "(20%) Bota momo for putalisadak",
            artwork:
              "https://dev-cdn-offer.fonepay.com/offercontent/offer/0963200b42d74819a1ab6e82d179e4ff",
            dealType: 1,
            dealDiscount: 20.0,
            subMerchants: [
              {
                id: "96b38e94-4dfa-479c-90c3-183a8b2852ee",
                categoryId: "ed5bd35f-b9a3-45e6-b470-41e0399829d7",
                name: "Bota Simply Momo (baneshwor)",
                longitude: 85.33695776728973,
                latitude: 27.692830589522426,
                distance: null,
                openNow: null,
                cover:
                  "https://dev-cdn-offer.fonepay.com/offercontent/d1977fee2beb4566ae770e0a3c9a0698"
              },
              {
                id: "de4916bf-611a-4433-9f0b-e3c34804c120",
                categoryId: "ed5bd35f-b9a3-45e6-b470-41e0399829d7",
                name: "Bota Simply Momo (near fawesomeapps)1",
                longitude: 85.32210916560666,
                latitude: 27.70173062091959,
                distance: null,
                openNow: null,
                cover:
                  "https://dev-cdn-offer.fonepay.com/offercontent/d1977fee2beb4566ae770e0a3c9a0698"
              },
              {
                id: "f7681568-728b-49e9-b4da-301939cb03c0",
                categoryId: "fe478c67-0489-11ea-96f5-04015db0f001",
                name: "Bota Simply Momo",
                longitude: 85.32593697567131,
                latitude: 27.715642176273082,
                distance: null,
                openNow: null,
                cover:
                  "https://dev-cdn-offer.fonepay.com/offercontent/merchant/fb496acd87c4498fab93b50f354311c6"
              }
            ],
            weight: 0.0
          },
          {
            id: "348b9be9-4f43-46e6-bc6b-f86d494f7725",
            title: "asdsssadasda",
            artwork:
              "https://dev-cdn-offer.fonepay.com/offercontent/offer/209c3ec8471f4162af265f89f878f032",
            dealType: 1,
            dealDiscount: 100.0,
            subMerchants: [
              {
                id: "81bd2c34-accd-41ae-b602-afb848054a65",
                categoryId: "354eec1e-b4b7-431b-a2e9-15fe027bbe56",
                name: "Ratna Jwelery",
                longitude: 85.32460659999992,
                latitude: 27.7121469,
                distance: null,
                openNow: null,
                cover:
                  "https://dev-cdn-offer.fonepay.com/offercontent/d1977fee2beb4566ae770e0a3c9a0698"
              },
              {
                id: "c9322194-3e22-4801-a99b-42cbdd2d0e60",
                categoryId: "25137336-cc9d-4d40-a196-2cdbb4f302ac",
                name: "Cartier Jwelery",
                longitude: 85.32460659999992,
                latitude: 27.7121469,
                distance: null,
                openNow: null,
                cover:
                  "https://dev-cdn-offer.fonepay.com/offercontent/d1977fee2beb4566ae770e0a3c9a0698"
              },
              {
                id: "f925f68d-bbc1-44b5-b151-7986ffef7e4c",
                categoryId: "25137336-cc9d-4d40-a196-2cdbb4f302ac",
                name: "Harry Winston Jwelery",
                longitude: 85.32460659999992,
                latitude: 27.7121469,
                distance: null,
                openNow: null,
                cover:
                  "https://dev-cdn-offer.fonepay.com/offercontent/d1977fee2beb4566ae770e0a3c9a0698"
              }
            ],
            weight: 0.0
          },
          {
            id: "b45335c3-256f-4371-96e4-5c08cc587db3",
            title: "(20%) Bota momo for putalisadak",
            artwork:
              "https://dev-cdn-offer.fonepay.com/offercontent/offer/0963200b42d74819a1ab6e82d179e4ff",
            dealType: 1,
            dealDiscount: 20.0,
            subMerchants: [
              {
                id: "96b38e94-4dfa-479c-90c3-183a8b2852ee",
                categoryId: "ed5bd35f-b9a3-45e6-b470-41e0399829d7",
                name: "Bota Simply Momo (baneshwor)",
                longitude: 85.33695776728973,
                latitude: 27.692830589522426,
                distance: null,
                openNow: null,
                cover:
                  "https://dev-cdn-offer.fonepay.com/offercontent/d1977fee2beb4566ae770e0a3c9a0698"
              },
              {
                id: "de4916bf-611a-4433-9f0b-e3c34804c120",
                categoryId: "ed5bd35f-b9a3-45e6-b470-41e0399829d7",
                name: "Bota Simply Momo (near fawesomeapps)1",
                longitude: 85.32210916560666,
                latitude: 27.70173062091959,
                distance: null,
                openNow: null,
                cover:
                  "https://dev-cdn-offer.fonepay.com/offercontent/d1977fee2beb4566ae770e0a3c9a0698"
              },
              {
                id: "f7681568-728b-49e9-b4da-301939cb03c0",
                categoryId: "fe478c67-0489-11ea-96f5-04015db0f001",
                name: "Bota Simply Momo",
                longitude: 85.32593697567131,
                latitude: 27.715642176273082,
                distance: null,
                openNow: null,
                cover:
                  "https://dev-cdn-offer.fonepay.com/offercontent/merchant/fb496acd87c4498fab93b50f354311c6"
              }
            ],
            weight: 0.0
          }
        ]
      }
    ]
  }
};

// CollectionList.js

// https://dev-api-offer-backend.fonepay.com/api/app/v1/submerchant/category/search?size=5
export const SubMerchantCategorySearch = {
  code: 200,
  message: "success",
  data: {
    pagination: {
      previous: null,
      next: 5,
      size: 5
    },
    subMerchantCategories: [
      {
        id: "112bcad2-8b41-4b6a-ae1c-71a697fef15f",
        name: "Furniture & Handicraft",
        description: "kjhj",
        offerCount: 7,
        image:
          "https://dev-cdn-offer.fonepay.com/offercontent/sub_merchant_category/62e1c8070e5a4ad48b4299e48fa0beb5"
      },
      {
        id: "19c9a793-d326-4f65-9805-d07b0828e062",
        name: "Electronics",
        description: "asd",
        offerCount: 1,
        image:
          "https://dev-cdn-offer.fonepay.com/offercontent/sub_merchant_category/ccdbba30d73e44e68777fca9d16df695"
      },
      {
        id: "25137336-cc9d-4d40-a196-2cdbb4f302ac",
        name: "Events",
        description: "Top jewelry brands",
        offerCount: 1,
        image:
          "https://dev-cdn-offer.fonepay.com/offercontent/sub_merchant_category/f7885a5459c44d4a9cb37c59ca1b375f"
      },
      {
        id: "354eec1e-b4b7-431b-a2e9-15fe027bbe56",
        name: "Entertainment",
        description: "asdasd",
        offerCount: 3,
        image:
          "https://dev-cdn-offer.fonepay.com/offercontent/sub_merchant_category/bc1102b97259470099a43863d1c918cb"
      },
      {
        id: "7cade5ee-093f-4f59-8de0-da8072eab0b0",
        name: "Travel & Tours",
        description: "",
        offerCount: 4,
        image:
          "https://dev-cdn-offer.fonepay.com/offercontent/sub_merchant_category/ba17299dac314d5eaf72e18a37dff52a"
      }
    ]
  }
};

export default FakeApiEnabled;
